import { createPortal } from 'react-dom';
import { useEffect, useState, useCallback } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { yomiriP2P } from '../../cast/YomiriP2PBridge.ts';
import { tvNavigationManager } from '../../network/tv/TvNavigationManager.ts';
import { tvPairingSync } from '../../network/pairing/TvPairingSync.ts';
import { YomiriTvLinkModal } from './YomiriTvLinkModal.tsx';
interface Props {
  onNavigate:(view:string,params?:any)=>void;
  onOpenManga?:(id:string,chapterId?:string,manga?:any)=>void;
  onSearch?:(query:string)=>void;
}
export function YomiriTvReceiverOverlay({onNavigate,onOpenManga,onSearch}:Props){
  const [modalOpen,setModalOpen]=useState(false);
  const [headerSlot,setHeaderSlot]=useState<HTMLElement|null>(null);
  useEffect(()=>{
    const update=()=>setHeaderSlot(document.getElementById('y-header-device-link'));
    update();const observer=new MutationObserver(update);observer.observe(document.body,{childList:true,subtree:true});
    return()=>observer.disconnect();
  },[]);
  const [peer,setPeer]=useState<string|null>(null);
  const [notice,setNotice]=useState('');
  const close=useCallback(()=>setModalOpen(false),[]);
  useEffect(()=>{
    const state=yomiriP2P.onState((value,name)=>{
      if(value==='connected'){setPeer(name||'Móvil');document.documentElement.dataset.yomiriTv='true';}
      else setPeer(null);
    });
    const commands=yomiriP2P.onCommand(cmd=>{
      if(yomiriP2P.getRole()!=='tv')return;
      if(cmd.type==='PLAYER_CONTROL'||cmd.type==='READER_CONTROL'||cmd.type==='DPAD_NAVIGATE')
        tvPairingSync.confirmReception('La TV recibió el control.');
      if(cmd.type==='NAVIGATE'){tvPairingSync.confirmReception('La TV navegó a la sección solicitada.');onNavigate(cmd.view,cmd.params);}
      else if(cmd.type==='SEARCH'){tvPairingSync.confirmReception('La TV recibió la búsqueda.');onSearch?.(cmd.query);}
      else if(cmd.type==='OPEN_MANGA'){tvPairingSync.confirmReception('La TV abrió el manga.');onOpenManga?.(cmd.id,cmd.chapterId,cmd.manga);}
      else if(cmd.type==='OPEN_ANIME'){
        tvPairingSync.confirmReception('La TV abrió el anime.');
        const params=new URLSearchParams({section:'anime',animeSource:cmd.sourceId,anime:cmd.animeId});
        if(cmd.episodeId)params.set('episode',cmd.episodeId);
        if(new URLSearchParams(location.search).has('receiver'))params.set('receiver','1');
        history.pushState(null,'',location.pathname+'?'+params);window.dispatchEvent(new PopStateEvent('popstate'));
      }else if(cmd.type==='DPAD_NAVIGATE'){
        if(cmd.key==='Enter'&&document.activeElement instanceof HTMLElement)document.activeElement.click();
        else if(cmd.key==='Escape')tvNavigationManager.handleBackKey();
        else if(['ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].includes(cmd.key))tvNavigationManager.handleDpadNavigation(cmd.key as any);
        else document.dispatchEvent(new KeyboardEvent('keydown',{key:cmd.key,bubbles:true}));
      }else if(cmd.type==='PLAYER_CONTROL'){
        window.dispatchEvent(new CustomEvent('yomiri-cast-player-control',{detail:cmd}));
        if(cmd.action==='toggle_fullscreen'){
          const action=document.fullscreenElement?document.exitFullscreen():document.documentElement.requestFullscreen();
          void action.catch(()=>setNotice('Este navegador requiere pulsar Pantalla completa en la TV.'));
        }else{
          for(const video of Array.from(document.querySelectorAll('video')).filter(item=>item.getClientRects().length>0)){
            if(cmd.action==='play')void video.play().catch(()=>setNotice('Pulsá reproducir una vez en la TV para habilitar el video.'));
            else if(cmd.action==='pause')video.pause();
            else if(cmd.action==='volume_up'){video.volume=Math.min(1,video.volume+.1);video.muted=false;}
            else if(cmd.action==='volume_down')video.volume=Math.max(0,video.volume-.1);
            else if(cmd.action==='mute')video.muted=!video.muted;
            else if(cmd.action==='seek'&&Number.isFinite(cmd.time)&&cmd.time!>=0)video.currentTime=cmd.time!;
          }
        }
      }else if(cmd.type==='READER_CONTROL'){
        const key=cmd.action==='next'?'ArrowRight':cmd.action==='prev'?'ArrowLeft':'f';
        document.dispatchEvent(new KeyboardEvent('keydown',{key,bubbles:true}));
      }
    });
    return()=>{state();commands();};
  },[onNavigate,onOpenManga,onSearch]);
  return <>
    <YomiriTvLinkModal open={modalOpen} onClose={close}/>
    {headerSlot && createPortal(<Box sx={{display:'flex',alignItems:'center',gap:1,flexShrink:0}}>
      <Button size="small" variant="outlined" onClick={()=>setModalOpen(true)}>{peer?'Móvil conectado':'Vincular móvil'}</Button>
      {peer&&<Button size="small" onClick={()=>yomiriP2P.disconnect()}>Desvincular</Button>}
    </Box>,headerSlot)}
    {notice&&<Box role="status" sx={{position:'fixed',bottom:24,right:24,zIndex:1400,bgcolor:'#18181b',p:2,border:'1px solid #52525b',maxWidth:340,fontSize:13}}>
      {notice}<Button onClick={()=>{void document.documentElement.requestFullscreen().then(()=>setNotice('')).catch(()=>{});}}>Pantalla completa</Button>
      <Button onClick={()=>setNotice('')}>Cerrar</Button>
    </Box>}
  </>;
}
